import createPersistedState from "use-persisted-state";

import storage from "./storage";

export default createPersistedState("hpAboutModal", storage);
